export default __webpack_public_path__ + "static/media/waSteps.7d1db8b4.png";